import React, { useState } from "react";
import {
  Popover,
  PopoverTrigger,
  PopoverContent,
  PopoverArrow,
  PopoverCloseButton,
  Button,
  FormControl,
  FormLabel,
  Input,
  useDisclosure,
  Stack,
  Portal,
  Td, // Import Td here
} from "@chakra-ui/react";
import FocusLock from "react-focus-lock";

const EditablePopover = ({ label, value, onSubmit, fieldName, maxW }) => {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [newValue, setNewValue] = useState(value);

  const handleSubmit = () => {
    onSubmit(fieldName, newValue);
    onClose();
  };

  return (
    <Popover isOpen={isOpen} onOpen={onOpen} onClose={onClose} isLazy>
      <PopoverTrigger>
        <Td
          px={1}
          py={1}
          onDoubleClick={onOpen}
          cursor="pointer"
          title={value ? `${value} — double-click to edit` : `Double-click to edit ${label}`}
          maxW={maxW}
          overflow={maxW ? "hidden" : undefined}
          textOverflow={maxW ? "ellipsis" : undefined}
          whiteSpace={maxW ? "nowrap" : undefined}
        >
          {value}
        </Td>
      </PopoverTrigger>
      {/* Portal is load-bearing: without it the PopoverContent div is a direct
          child of the <tr>, and the browser's table fixup wraps it in an
          anonymous CELL — every field column after it shifts right (the
          header/body misalignment bug). */}
      <Portal>
        <PopoverContent p={5}>
          <FocusLock returnFocus persistentFocus={false}>
            <PopoverArrow />
            <PopoverCloseButton />
            <Stack spacing={4}>
              <FormControl>
                <FormLabel>Edit {label}</FormLabel>
                <Input value={newValue} onChange={(e) => setNewValue(e.target.value)} />
              </FormControl>
              <Button colorScheme="teal" onClick={handleSubmit}>
                Save
              </Button>
            </Stack>
          </FocusLock>
        </PopoverContent>
      </Portal>
    </Popover>
  );
};

export default EditablePopover;
